<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Entrées (Achats)</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Liste des Achats</h3>
        <div class="card-options d-flex gap-2">
          <button class="btn btn-outline-success btn-sm" @click="showCreatePurchaseModal">
            <i class="fe fe-plus-circle me-1"></i> Ajouter
          </button>
          <button class="btn btn-outline-info btn-sm" @click="exportCSV">
            <i class="fe fe-download me-1"></i> Exporter
          </button>
        </div>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="filterableFields"
            :row-actions="rowActions"
            :items="purchases"
            @edit="onEdit"
            @delete="onDelete"
            @validate="onValidate"
            @reject="onReject"
            @history="onHistory"
        >
          <template #cell-id="{ item }">
            <strong>#{{ item.id }}</strong>
          </template>
          <template #cell-totalAmount="{ item }">
            {{ item.totalAmount.toFixed(2) }} €
          </template>
          <template #cell-reference="{ item }">
            <span class="text-primary fw-bold">{{ item.reference }}</span>
          </template>

          <template #cell-status="{ item }">
  <span class="badge"
        :class="{
          'bg-success': item.status === 'VALIDATED',
          'bg-warning': item.status === 'REGISTERED',
          'bg-secondary': item.status === 'STORED',
          'bg-danger': item.status === 'REJECTED'
        }">
    {{ item.status }}
  </span>
          </template>

          <template #cell-createdDate="{ item }">
            {{ new Date(item.createdDate).toLocaleString() }}
          </template>
        </TableWithFilters>
      </div>
    </div>

    <!-- Modal dynamique -->
    <modal-create-purchase
        :purchase="selectedPurchase"
        @refresh="loadPurchases"
    />
  </div>
</template>

<script>


  import TableWithFilters from "../../../components/TableWithFilters.vue";
  import ModalCreatePurchase from "../../../components/modals/ModalCreatePurchase.vue";
  import {
    FILTER_TYPES,
    purchaseColumns,
    purchaseFilterableFields,
    purchaseRowActions
  } from "../../../helpers/constants";
  import {showValidationErrors} from "../../../helpers/helpers";

  export default {
    name: "Achats",
    components: {ModalCreatePurchase, TableWithFilters},
    data() {
      return {
        purchases: [],
        selectedPurchase: null,
        columns: purchaseColumns,
        filterableFields: purchaseFilterableFields,
        rowActions: purchaseRowActions,
      };
    },
    methods: {
      showCreatePurchaseModal() {
        this.selectedPurchase = null;
        $('#modal-create-purchase').modal('show');
      },
      loadPurchases() {
        this.$loading(true);
        this.$http
            .get("/purchases")
            .then(({ data }) => {
              this.purchases = data;
            })
            .catch((err) => {
              console.error("Erreur chargement achats :", err);
            })
            .finally(() => this.$loading(false));
      },
      onEdit(item) {
        this.selectedPurchase = { ...item };
        $('#modal-create-purchase').modal('show');
      },
      onDelete(item) {
        this.$swal({
          title: 'Confirmation',
          text: `Voulez-vous supprimer l'achat #${item.id} ?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui, supprimer',
          cancelButtonText: 'Annuler',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$loading(true);
            this.$http
                .delete(`/purchases/${item.id}`)
                .then(() => {
                  this.$swal('Supprimé', 'Achat supprimé avec succès.', 'success');
                  this.loadPurchases();
                })
                .catch(err => showValidationErrors(err))
                .finally(() => this.$loading(false));
          }
        });
      },
      onValidate(item) {
        this.$swal({
          title: 'Valider',
          text: `Voulez-vous valider l'achat #${item.id} ?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Oui, valider',
          cancelButtonText: 'Annuler',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$loading(true);
            this.$http.get(`/purchases/${item.id}/VALIDATE`)
                .then(() => {
                  this.$swal('Validé', 'Achat validé avec succès.', 'success');
                  this.loadPurchases();
                })
                .catch(showValidationErrors)
                .finally(() => this.$loading(false));
          }
        });
      },
      onReject(item) {
        this.$http.get(`/purchases/${item.id}/REJECT`)
            .then(({ data }) => {
              const example = data.example;
              this.$swal({
                title: 'Rejeter Achat',
                input: 'text',
                inputLabel: 'Commentaire de rejet',
                inputPlaceholder: 'Ex: erreur de saisie',
                showCancelButton: true,
                confirmButtonText: 'Rejeter',
                cancelButtonText: 'Annuler'
              }).then(result => {
                if (result.isConfirmed) {
                  this.$loading(true);
                  this.$http.post(`/purchases/reject`, {
                    reference: example.reference,
                    comment: result.value
                  }).then(() => {
                    this.$swal('Rejeté', 'L\'achat a été rejeté.', 'success');
                    this.loadPurchases();
                  }).catch(showValidationErrors)
                      .finally(() => this.$loading(false));
                }
              });
            });
      },
      onHistory(item) {
        this.$http.get(`/purchases/${item.id}/history`)
            .then(({ data }) => {
              const html = data.map(h => `
        <li><strong>${h.status}</strong> à ${new Date(h.timestamp).toLocaleString()}</li>
      `).join('');
              this.$swal({
                title: `Historique de l'achat #${item.id}`,
                html: `<ul style="text-align:left">${html}</ul>`,
                confirmButtonText: 'Fermer'
              });
            });
      },

      exportCSV() {
        const headers = this.columns.map(col => col.label);
        const rows = this.purchases.map(row =>
            this.columns.map(col => `"${row[col.key] ?? ''}"`).join(",")
        );
        const csvContent = [headers.join(","), ...rows].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "achats.csv");
        link.click();
        URL.revokeObjectURL(url);
      },
    },
    mounted() {
      this.loadPurchases();
    },
  };
</script>
